<div class="login-container" [ngClass]="{'!w-[327px] !p-6': bp.isCompact()}">
  <div class="heading-title">
    <span class="title-text">¡Bienvenido!</span>
    <span class="body-text"
      >Ingresa tus datos para acceder a la plataforma administrativa:</span
    >
  </div>
  <div class="w-full">
    <form class="form-styles" [formGroup]="loginForm">
      <mg-input
        label="Correo electrónico"
        placeholder="ejemplo@mail.com"
        class="w-full"
        [ngClass]="{'min-w-[340px]': !bp.isCompact()}"
        [required]="true"
        [errors]="{
          required: 'Este campo no puede quedar vacío.',
          email: 'El correo electrónico es incorrecto.',
          manualError: 'Datos no coinciden. Intenta de nuevo.',
        }"
        [control]="$any(loginForm.get('email'))"
        [value]="loginForm.value.email"
        (keydown.enter)="onEnterKey($event)"
        id="emailInput"
      ></mg-input>
      <mg-input
        label="Contraseña"
        placeholder="**********"
        type="password"
        class="w-full"
        [ngClass]="{'min-w-[340px]': !bp.isCompact()}"
        [required]="true"
        [errors]="{
          required: 'Este campo no puede quedar vacío.',
          manualError: 'Datos no coinciden. Intenta de nuevo.',
        }"
        [control]="$any(loginForm.get('password'))"
        [value]="loginForm.value.password"
        (keydown.enter)="onEnterKey($event)"
        id="passwordInput"
        mgTitle="Mostrar u ocultar contraseña"
      ></mg-input>
      <div class="toggle-container">
        <mg-toggle
          [label]="'Recordar mi usuario'"
          [isReversed]="true"
          [value]="loginForm.value.remember"
          (activeChange)="setRemember($event)"
        >
        </mg-toggle>
      </div>
    </form>
  </div>
  <div class="buttons-container">
    <mg-button
      [disabled]="!loginForm.value.email || !loginForm.value.password"
      [loading]="loading"
      class="w-full"
      (click)="onSubmit()"
      (keypress.enter)="onSubmit()"
      (keypress.space)="onSubmit()"
      >Iniciar sesión</mg-button
    >
    <span class="forgot-text"
      >¿Olvidaste tu contraseña?
      <a routerLink="../restore-password" class="link-forgot-text"
        >Recupérala</a
      >
    </span>
  </div>
</div>
